import React, { Component } from "react";
import { connect } from "react-redux";
import { Card, Spin } from "antd";
import { req_list_pim_staff_leave_statistics } from "../../api";

const css = `
.sls-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.sls-table {
  border-collapse: collapse;
  font-size: 13px;
  min-width: 760px;
  width: 100%;
  table-layout: fixed;
}
.sls-table th,
.sls-table td {
  border: 1px solid #ccc;
  padding: 4px 6px;
  text-align: center;
  vertical-align: middle;
  white-space: pre-wrap;
  word-break: break-word;
}
.sls-th-available {
  background-color: #a691b6;
  font-weight: bold;
  color: rgb(127, 35, 132);
}
.sls-th-taken {
  background-color: #e9cdff;
  font-weight: bold;
  color: rgb(127, 35, 132);
}
.avail-td-ltype {
  background-color: #a691b6;
  font-weight: bold;
  width: 60px;
}
.sls-td-ltype {
  background-color: #e9cdff;
  font-weight: bold;
  width: 60px;
}
.sls-td-amount {
  width: 64px;
}
.sls-td-staff {
  background-color: #dcd6e7;
  width: 100px;
}
.sls-staff-id   { color: #1565c0; font-weight: bold; font-size: 14px; }
.sls-staff-name { font-size: 14px; font-weight: bold; margin: 2px 0; }
.sls-staff-title{ font-size: 12px; color: #555; }
.sls-photo {
  width: 56px;
  height: 56px;
  border-radius: 4px;
  background: #d0d0d0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 4px;
  overflow: hidden;
}
.sls-photo img { width: 100%; height: 100%; object-fit: cover; }
.sls-photo-placeholder {
  width: 32px; height: 32px; opacity: .45;
}

/* Mobile card layout */
@media (max-width: 767px) {
  .sls-wrapper { overflow-x: auto; }
  .sls-table   { font-size: 11px; }
  .sls-table th,
  .sls-table td { padding: 3px 4px; }
}
`;

class StaffLeaveStatistics extends Component {
  state = {
    loading: true,
    deviceWidth: window.innerWidth,
    item: {},
    items: {
      staffList: [
        {
          id: "--",
          name: "--",
          title: "--",
          photo: null,
          availableLeave: [
            { type: "事假", amount: "--" },
            { type: "病假", amount: "--" },
            { type: "休假", amount: "--" },
            { type: "補休", amount: "--" },
            { type: "遞延休假", amount: "--" },
          ],
          takenLeave: [
            [
              { type: "事假", amount: "--" },
              { type: "家庭照顧假", amount: "--" },
              { type: "婚假", amount: "--" },
              { type: "骨髓或\n器官捐\n贈假", amount: "--" },
            ],
            [
              { type: "病假", amount: "--" },
              { type: "生理假", amount: "--" },
              { type: "娩假", amount: "--" },
              { type: "喪假", amount: "--" },
            ],
            [
              { type: "休假", amount: "--" },
              { type: "公假", amount: "--" },
              { type: "陪產檢及\n陪產假", amount: "--" },
              { type: "產檢假", amount: "--" },
            ],
            [
              { type: "補休", amount: "--" },
              { type: "差假", amount: "--" },
              { type: "流產假", amount: "--" },
              { type: "產前假", amount: "--" },
            ],
            [
              { type: "遞延休假", amount: "--" },
              { type: "", amount: "" },
              { type: "", amount: "" },
              { type: "", amount: "--" },
            ],
          ],
        },
      ],
    },
  };

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
    this.api_item_data();
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => this.setState({ deviceWidth: window.innerWidth });

  isPositiveAmount = (amount) => {
    if (!amount || amount === "--") return false;
    const nums = amount.match(/\d+/g);
    return nums ? nums.some((n) => parseInt(n, 10) > 0) : false;
  };

  renderPhoto(staff) {
    return (
      <div className="sls-photo">
        {staff.photo ? (
          <img src={staff.photo} alt={staff.name} />
        ) : (
          <svg
            className="sls-photo-placeholder"
            viewBox="0 0 48 48"
            fill="#888"
          >
            <circle cx="24" cy="18" r="10" />
            <path d="M4 44c0-11 8.954-20 20-20s20 9 20 20" />
          </svg>
        )}
      </div>
    );
  }
  /*
    PASS01 差假
    PASS02 公差
    PASS03 公假
    PASS04 公假(行政研習)
    PASS05 公假(教師研習)
    PASS06 喪假
    PASS07 婚假
    PASS08 產檢假
    PASS09 陪產檢及陪產假
    PASS10 娩假
    PLeave01 事假
    PLeave02 家庭照顧假
    ALeave01 休假
    SLeave01 病假
    SLeave02 生理假
    CTime01  補休假
    CLeave01 遞延休假
  */

  api_item_data = async () => {
    const { staffList } = this.state.items;
    const { token, userCode } = this.props.user;
    const result = await req_list_pim_staff_leave_statistics(userCode, token);
    console.log("data:", result);
    if (result !== null) {
      const item = result;
      const staff = staffList[0];
      staff.id = item.StaffCode;
      staff.name = item.StaffName;

      staff.availableLeave[0].amount = this.convertToWorkDaysPadded(
        item.PersonalHours /*事假*/,
      );
      staff.availableLeave[1].amount = this.convertToWorkDaysPadded(
        item.SickHours /*病假*/,
      );
      staff.availableLeave[2].amount = this.convertToWorkDaysPadded(
        item.AnnualHours /*休假*/,
      );
      staff.availableLeave[3].amount = this.convertToWorkDaysPadded(
        item.CompTimeHours /*補休*/,
      );
      staff.availableLeave[4].amount = this.convertToWorkDaysPadded(
        item.CarriedoverLeaveHours /*遞延休假*/,
      );
      //第一行
      staff.takenLeave[0][0].amount = this.convertToWorkDaysPadded(
        item.PLeave01 /*事假*/,
      );
      staff.takenLeave[0][1].amount = this.convertToWorkDaysPadded(
        item.PLeave02 /*家庭照顧假*/,
      );
      staff.takenLeave[0][2].amount = this.convertToWorkDaysPadded(
        item.PASS07 /*婚假*/,
      );
      //第二行
      staff.takenLeave[1][0].amount = this.convertToWorkDaysPadded(
        item.SLeave01 /*病假*/,
      );
      staff.takenLeave[1][1].amount = this.convertToWorkDaysPadded(
        item.SLeave02 /*生理假*/,
      );
      staff.takenLeave[1][2].amount = this.convertToWorkDaysPadded(
        item.PASS10 /*娩假*/,
      );
      staff.takenLeave[1][3].amount = this.convertToWorkDaysPadded(
        item.PASS06 /*喪假*/,
      );
      //第三行
      staff.takenLeave[2][0].amount = this.convertToWorkDaysPadded(
        item.ALeave01 /*休假*/,
      );
      staff.takenLeave[2][1].amount = this.convertToWorkDaysPadded(
        item.PASS03 /*公假*/,
      );
      staff.takenLeave[2][2].amount = this.convertToWorkDaysPadded(
        item.PASS09 /*陪產檢及陪產假*/,
      );
      staff.takenLeave[2][3].amount = this.convertToWorkDaysPadded(
        item.PASS08 /*產檢假*/,
      );
      //第四行
      staff.takenLeave[3][0].amount = this.convertToWorkDaysPadded(
        item.CTime01 /*補休*/,
      );
      staff.takenLeave[3][1].amount = this.convertToWorkDaysPadded(
        item.PASS02 /*公差*/,
      );
      staff.takenLeave[4][0].amount = this.convertToWorkDaysPadded(
        item.CLeave01 /*遞延休假*/,
      );
      this.setState({ loading: false, items: { staffList: [staff] } });
    } else {
      this.setState({ loading: false });
    }
  };

  convertToWorkDaysPadded = (totalHours) => {
    if (totalHours === null || totalHours === undefined) return "--";
    if (typeof totalHours !== "number" || totalHours < 0) return "--";

    const hoursPerDay = 8;
    const days = Math.floor(totalHours / hoursPerDay);
    const hours = Math.floor(totalHours % hoursPerDay);

    if (days === 0 && hours === 0) return "--";

    const paddedDays = days.toString().padStart(2, "0");
    const paddedHours = hours.toString().padStart(2, "0");

    return `${paddedDays}日${paddedHours}時`;
  };

  renderStaffTable(staff) {
    const rowCount = staff.availableLeave.length;

    return (
      <table className="sls-table" key={staff.id}>
        <colgroup>
          <col style={{ width: 100 }} />
          <col style={{ width: 56 }} />
          <col style={{ width: 72 }} />
          <col style={{ width: 60 }} />
          <col style={{ width: 64 }} />
          <col style={{ width: 68 }} />
          <col style={{ width: 64 }} />
          <col style={{ width: 60 }} />
          <col style={{ width: 64 }} />
          <col style={{ width: 72 }} />
          <col style={{ width: 64 }} />
        </colgroup>
        <thead>
          <tr>
            <th rowSpan={2} className="sls-td-staff"></th>
            <th colSpan={2} className="sls-th-available">
              可請(休)假
            </th>
            <th colSpan={8} className="sls-th-taken">
              本期已請(休)假
            </th>
          </tr>
          <tr>
            <th className="sls-th-available">假別</th>
            <th className="sls-th-available">天數/時數</th>
            <th className="sls-th-taken">假別</th>
            <th className="sls-th-taken">天數/時數</th>
            <th className="sls-th-taken">假別</th>
            <th className="sls-th-taken">天數/時數</th>
            <th className="sls-th-taken">假別</th>
            <th className="sls-th-taken">天數/時數</th>
            <th className="sls-th-taken">假別</th>
            <th className="sls-th-taken">天數/時數</th>
          </tr>
        </thead>
        <tbody>
          {staff.availableLeave.map((avail, rowIdx) => {
            const taken = staff.takenLeave[rowIdx] || [];
            return (
              <tr key={rowIdx}>
                {rowIdx === 0 && (
                  <td rowSpan={rowCount} className="sls-td-staff">
                    {this.renderPhoto(staff)}
                    <div className="sls-staff-id">{staff.id}</div>
                    <div className="sls-staff-name">{staff.name}</div>
                  </td>
                )}
                <td className="avail-td-ltype">{avail.type}</td>
                <td
                  className="sls-td-amount"
                  style={
                    this.isPositiveAmount(avail.amount)
                      ? { color: "#1565c0" }
                      : undefined
                  }
                >
                  {avail.amount}
                </td>
                {taken.map((t, colIdx) => [
                  <td key={`t${colIdx}`} className="sls-td-ltype">
                    {t.type}
                  </td>,
                  <td
                    key={`a${colIdx}`}
                    className="sls-td-amount"
                    style={
                      this.isPositiveAmount(t.amount)
                        ? { color: "#1565c0" }
                        : undefined
                    }
                  >
                    {t.amount}
                  </td>,
                ])}
                {/* pad missing taken columns */}
                {Array.from({ length: 4 - taken.length }).map((_, i) => [
                  <td key={`pt${i}`} />,
                  <td key={`pa${i}`} />,
                ])}
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }

  render() {
    const { loading, items } = this.state;
    const staffList = this.props.staffList || items.staffList;

    return (
      <>
        <style>{css}</style>
        <Card title="員工請假統計" size="small" style={{ marginBottom: 16 }}>
          <Spin spinning={loading}>
            {staffList.map((staff) => (
              <div
                key={staff.id}
                className="sls-wrapper"
                style={{ marginBottom: 16 }}
              >
                {this.renderStaffTable(staff)}
              </div>
            ))}
          </Spin>
        </Card>
      </>
    );
  }
}

const mapStateToProps = (state) => ({ user: state.user });
export default connect(mapStateToProps)(StaffLeaveStatistics);
